import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-report-reason',
  templateUrl: './report-reason.component.html',
  styleUrls: ['./report-reason.component.scss']
})
export class ReportReasonComponent implements OnInit {
  userDetail: any;
  httpHeaders: any;
  isLoading: boolean = true;
  listOfReportReason: any = [];
  @Output() closeActivityAtDialog: EventEmitter<any> = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<ReportReasonComponent>,
    private toastr: ToastrService,
    public as: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {
    console.log(data);
    dialogRef.disableClose = true;

    this.userDetail = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetail['accessToken']}`,
    });
  }
  ngOnInit(): void {
    this.fetchAllCommunity();
  }
  async fetchAllCommunity() {
    this.isLoading = true;
    try {
      this.listOfReportReason = [];

      const URL = `${webApi.domain + webApi.endPoint.fetchCommentReportReason}/${this.data['id']}`;
      await this.as.fetchDetailViaGet(URL, this.httpHeaders).then((data: any) => {
        if (data['success']) {
          this.listOfReportReason = data['result'];
        }
        this.isLoading = false;
      });
    } catch (error) {
      this.isLoading = false;
    }
  }
  close() {
    this.dialogRef.close();
    this.closeActivityAtDialog.emit(null);
  }
}
